import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getPageHeadersConfigs() {
    return {
        custom: {
            [PALETTE_IDS.INTERFACE]: {
                ApplicationMenu: {
                    logo: {
                        style: {
                            height: 32,
                            width: 127,
                        },
                    },
                    logoButton: {
                        style: {
                            base: {
                                padding: '0px 0px 0px 8px',
                            },
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.APPLICATION_HEADER]: {
                APPLICATION_HEADER_BG: COLOR.BRAND.BACKGROUND6,
                APPLICATION_HEADER_NAV_BAR_PAGE_SELECTOR: {
                    PIVOT_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                        textTransform: 'uppercase',
                    },
                    PIVOT_SELECTED_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                        textTransform: 'uppercase',
                    },
                    PIVOT_INDICATOR_HEIGHT: 0,
                },
                SEARCH_POPOVER: {
                    POPOVER_BG: COLOR.BRAND.BACKGROUND4,
                    POPOVER_TEXT: COLOR.BRAND.FOREGROUND2,
                },
            },
            [PALETTE_IDS.INTERFACE]: {
                BANNER_BG: COLOR.BASE.PAGE,
                BANNER_TEXT: COLOR.BRAND.FOREGROUND1,
                SYSTEM_INITIALIZATION_TEXT: COLOR.RESERVED.WHITE,
            },
            [PALETTE_IDS.SETTINGS]: {
                SETTINGS_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                    fontSize: FONT.SIZE_MEDIUM,
                },
            },
        },
    };
}
